/* eslint-disable camelcase */

export class PurePoint {
  constructor ({ id = -1, point = [], datetime = 0, datetime_diff = 0, speed = 0.0, location_accuracy = 0, satellite_count = 0 } = {}) {
    this.id = id
    this.point = point
    this.datetime = datetime
    this.datetimeDiff = datetime_diff
    this.speed = speed
    this.locationAccuracy = location_accuracy
    this.satelliteCount = satellite_count
  }
}
